import React from 'react';
import PropTypes from 'prop-types';

import { extendedServiceStopStatuses } from 'types/timetableServices';
import { formatTime } from 'utils/dates';

import { TimetableItem, TimetableTime, TimetableItemDetails, TimetableStationName, TimetableDetailData } from './StopsSummary.style';

const StopCancelled = ({ arrivalDateTime, departureDateTime, stationName, stopNumber, dark }) => {
  const firstStop = stopNumber === 0;
  const time = firstStop ? formatTime(departureDateTime) : formatTime(arrivalDateTime);

  return (
    <TimetableItem data-testid={`timetable-service-stop-cancelled-${stopNumber}`} dark={dark}>
      <TimetableTime>
        <TimetableDetailData status={extendedServiceStopStatuses.CANCELLED}>{time}</TimetableDetailData>
      </TimetableTime>
      <TimetableItemDetails>
        <TimetableStationName status={extendedServiceStopStatuses.CANCELLED}>{stationName}</TimetableStationName>
      </TimetableItemDetails>
    </TimetableItem>
  );
};

StopCancelled.propTypes = {
  dark: PropTypes.bool,
  arrivalDateTime: PropTypes.instanceOf(Date),
  departureDateTime: PropTypes.instanceOf(Date),
  stationName: PropTypes.string,
  stopNumber: PropTypes.number
};

export default StopCancelled;
